import useTracking from "./useTracking"

const useFormTracking = () => {
  const { track, trackView } = useTracking()

  /**
   * Tracks when a user views an email sign-up form.
   */
  const trackEmailFormView = (elementRef, trackingId, extraProps) => {
    trackView(
      elementRef,
      trackingId,
      { category: "Registration", ...extraProps },
      (props) => track("Email Signup Form Viewed", props),
      "emailViewed",
    )
  }

  /**
   * Tracks when a user views a webinar sign-up form.
   */
  const trackWebinarFormView = (elementRef, trackingId, extraProps) => {
    trackView(
      elementRef,
      trackingId,
      { category: "Webinar", ...extraProps },
      (props) => track("Webinar Form Viewed", props),
      "webinarViewed",
    )
  }

  return { trackEmailFormView, trackWebinarFormView }
}

export default useFormTracking
